import React from "react";
import InvoiceSearchableMultiSelectMenu from "../../Invoicing/InvoiceSearchableMultiSelectMenu";

export type EventSalesMultiSelectOption<Value extends string> = Readonly<{
  label: string;
  value: Value;
}>;

type EventSalesSearchableMultiSelectMenuProps<Value extends string> = Readonly<{
  anchorEl: HTMLElement | null;
  ariaLabel: string;
  onChange: (values: Value[]) => void;
  onClose: () => void;
  options: ReadonlyArray<EventSalesMultiSelectOption<Value>>;
  searchPlaceholder: string;
  values: Value[];
}>;

const EventSalesSearchableMultiSelectMenu = <Value extends string>({
  anchorEl,
  ariaLabel,
  onChange,
  onClose,
  options,
  searchPlaceholder,
  values,
}: EventSalesSearchableMultiSelectMenuProps<Value>) => {
  const toggleValue = (value: Value) => {
    onChange(
      values.includes(value)
        ? values.filter((selectedValue) => selectedValue !== value)
        : [...values, value],
    );
  };

  return (
    <InvoiceSearchableMultiSelectMenu
      anchorEl={anchorEl}
      ariaLabel={ariaLabel}
      onClose={onClose}
      options={options.map((option) => ({
        checked: values.includes(option.value),
        id: option.value,
        label: option.label,
        onSelect: () => toggleValue(option.value),
      }))}
      searchPlaceholder={searchPlaceholder}
      testIdPrefix="event-sales-searchable-filter"
    />
  );
};

export default EventSalesSearchableMultiSelectMenu;
